import ArchitectureSection from '../sections/ArchitectureSection'

const ArchitecturePage = () => <ArchitectureSection />

export default ArchitecturePage
